function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// typed-ember has not published types for this yet
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { createCache, getValue } from '@glimmer/tracking/primitives/cache';
import { setOwner } from '@ember/application';
import { associateDestroyableChild, registerDestructor } from '@ember/destroyable'; // typed-ember has not published types for this yet
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

import { capabilities as helperCapabilities, setHelperManager } from '@ember/helper';
export class LifecycleResource {
  constructor(owner, args) {
    this.args = args;
    setOwner(this, owner);
  }

}

class LifecycleResourceManager {
  constructor(owner) {
    _defineProperty(this, "capabilities", helperCapabilities('3.23', {
      hasValue: true,
      hasDestroyable: true
    }));

    this.owner = owner;
  }

  createHelper(Class, args) {
    let owner = this.owner;
    let instance;
    let cache = createCache(() => {
      if (instance === undefined) {
        instance = setupInstance(cache, Class, owner, args);
      } else {
        instance.update();
      }

      return instance;
    });
    return cache;
  }

  getValue(cache) {
    let instance = getValue(cache);
    return instance;
  }

  getDestroyable(cache) {
    return cache;
  }

}

function setupInstance(cache, Class, owner, args) {
  let instance = new Class(owner, args);
  associateDestroyableChild(cache, instance);

  if ('setup' in instance) {
    instance.setup();
  }

  if ('teardown' in instance) {
    registerDestructor(instance, () => instance.teardown());
  }

  return instance;
}

setHelperManager(owner => new LifecycleResourceManager(owner), LifecycleResource);